import { AxiosPromise } from "axios";
import { CONSTANT_CONFIG } from "@/constants";
import { HttpService } from "@/services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.QIS_SERVER_PREFIX}/training-category`;
const endpoints = {
    list: () => `${RESOURCE_ENDPOINT}`,
    getById: (id: any) => `${RESOURCE_ENDPOINT}/${id}`,
    checkIsDuplicateCategoryName: () => `${RESOURCE_ENDPOINT}/check-is-duplicate-category-name`,
    create: () => `${RESOURCE_ENDPOINT}`,
    update: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    updatePartial: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    delete: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    bulk: () => `${RESOURCE_ENDPOINT}/bulk`,
    getTrainingCategoryTree: () => `${RESOURCE_ENDPOINT}/getTrainingCategoryTree`,
    dropdown: () => `${RESOURCE_ENDPOINT}/dropdown`,
    dropdownAll: () => `${RESOURCE_ENDPOINT}/dropdown-all`,
};

export default class TrainingCategoryApi {
    public list = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.list();

        return HttpService.get(url, params, headers);
    };

    public getById = (id: any): AxiosPromise<any> => {
        const url = endpoints.getById(id);
        return HttpService.get(url);
    };

    public checkIsDuplicateCategoryName = (params = {}): AxiosPromise<any> => {
        const url = endpoints.checkIsDuplicateCategoryName();
        return HttpService.get(url, params);
    };

    public getTrainingCategoryTree = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getTrainingCategoryTree();
        return HttpService.get(url, params, headers);
    };

    public create = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.create();
        return HttpService.post(url, payload, params, headers);
    };

    public update = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.update(id);
        return HttpService.put(url, payload, params, headers);
    };

    public updatePartial = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.updatePartial(id);
        return HttpService.patch(url, payload, params, headers);
    };

    public delete = (id: any, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.delete(id);
        return HttpService.delete(url, params, headers);
    };

    public bulk = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.bulk();
        return HttpService.post(url, payload, params, headers);
    };

    public dropdown = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.dropdown();
        return HttpService.get(url, params, headers);
    };
    public dropdownAll = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.dropdownAll();
        return HttpService.get(url, params, headers);
    };
}
